import { loadEnvironmentFactory } from '../environments/loadEnvironment.factory';
export function tokenGetter() {
    return localStorage.getItem('tk');
}
var ɵ0 = loadEnvironmentFactory, ɵ1 = window;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
